import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { X, Trash2 } from 'lucide-react'
import { Button } from '../ui/button'
import toast from '../../utilities/toast'

function DeleteGroupDialog({ isOpen, onClose, onConfirm, groupName }) {
  const [isDeleting, setIsDeleting] = useState(false)

  const handleDelete = async () => {
    setIsDeleting(true)
    try {
      await onConfirm()
      toast.success('Group conversation deleted')
    } catch {
      toast.error('Failed to delete group conversation')
    } finally {
      setIsDeleting(false)
    }
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold text-gray-900">Delete Group</h2>
          <Button onClick={onClose} variant="ghost" size="icon" disabled={isDeleting} aria-label="Close">
            <X className="w-5 h-5" />
          </Button>
        </div>

        <div className="p-4">
          <div className="flex items-start gap-3 p-3 bg-red-50 border border-red-200 rounded-lg">
            <Trash2 className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div className="text-sm text-red-900 text-pretty">
              <p className="font-medium mb-1">Delete &ldquo;{groupName}&rdquo;?</p>
              <p>This will permanently delete the group and all messages for every participant. This cannot be undone.</p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 p-4 border-t border-gray-200">
          <Button onClick={onClose} variant="outline" disabled={isDeleting}>
            Cancel
          </Button>
          <Button onClick={handleDelete} disabled={isDeleting} className="bg-red-600 hover:bg-red-700 text-white">
            {isDeleting ? 'Deleting...' : 'Delete Group'}
          </Button>
        </div>
      </div>
    </div>
  )
}

DeleteGroupDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  groupName: PropTypes.string
}

export default DeleteGroupDialog
